import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ListItemText, MenuItem, Popover, makeStyles } from '@material-ui/core';
import { isEmpty } from 'lodash';
import Input from 'components/forms/Input';
import PlusIcon from 'mdi-react/PlusIcon';
import { primary1000, secondary0, secondary300 } from '../../themes/colors';

const useStyles = makeStyles(theme => ({
  '@global': {
    '*::-webkit-scrollbar': { display: 'none' },
  },
  customWidth: {
    whiteSpace: 'normal',
    '& div': {
      maxWidth: '20rem',
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: '0.875em',
      letterSpacing: '-0.01em',
      color: theme.palette.secondary.text,
      wordWrap: 'break-word',
      marginBottom: '0.5rem',
    },
  },
  optionStyle: {
    overflowY: 'auto',
    maxHeight: '12.5rem',
  },
  tabStyle: {
    alignItems: 'center',
    gap: '12px',
    background: secondary0,
    border: 'none',
    maxWidth: '30rem',
    borderRadius: '0.375rem',
    zIndex: 1310,
    paddingBottom: '0.312rem',
  },
  createNew: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
    padding: '0.625rem',
    margin: '0rem',
    background: '#EBFAF6',
    fontWeight: '600',
    fontSize: '0.875em',
    cursor: 'pointer',
    color: primary1000,
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
  },
  plusIcon: {
    marginRight: '0.4rem',
    marginTop: '-0.15rem',
  },
  popOverStyle: {
    boxShadow: `${theme.shadows[1]} !important`,
    border: `0.0625rem solid ${secondary300} !important`,
    borderRadius: '0.375rem',
    boxSizing: 'border-box',
    maxWidth: '20rem',
  },
  noOption: {
    fontSize: '0.875em',
    letterSpacing: '-0.01em',
    color: theme.palette.secondary.text,
    wordWrap: 'break-word',
    margin: '0.625rem 1.25rem',
    width: '30rem',
  },
  inputBox: {
    maxWidth: '28rem',
    border: 'none',
    margin: '0.5rem 0.5rem 0rem 0.5rem',
    '&:hover, &:focus, &:focus-within, &:active': {
      border: 'none',
    },
  },
}));

function SearchDropDownTab(props) {
  const classes = useStyles();
  const options = props.values ? props.options.filter(data =>
    !props.values.some(select => data.id === select.id)) : props.options;
  const [input, setInput] = useState('');

  const handleClose = () => {
    props.setAnchorEl(null);
    setInput('');
  };
  return (
    <Popover
      classes={{
        paper: classes.popOverStyle,
      }}
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: props.position.anchor.vertical, horizontal: props.position.anchor.horizontal }}
      transformOrigin={{ vertical: props.position.transform.vertical, horizontal: props.position.transform.horizontal }}
    >
      <div className={classes.tabStyle}>
        <Input
          onChange={(e) => {
            props.handleSearch(e.target.value);
            setInput(e.target.value);
          }}
          placeholder={props.seachPlaceholder}
          className={classes.inputBox}
        />
        <div className={classes.optionStyle}>
          {options.map(item =>
          <>
            <MenuItem className={classes.customWidth}>
              <ListItemText
                onClick={e => props.actionHandler(e, item.id)}
                primary={item.article_title || item.title}
                disableTypography
                style={{ wordWrap: 'break-word' }}
              />
            </MenuItem>
          </>)}
          {!props.isLoading && isEmpty(options) && input.length === 0 &&
            <>
              <ListItemText
                className={classes.noOption}
                primary="No data available"
                disableTypography
              />
            </>}
        </div>
      </div>
      {!props.isLoading && isEmpty(props.options) && input.length > 0 &&
        <div className={classes.createNew}>
          <ListItemText
            onClick={() => props.toggle(input)}
            primary={<><PlusIcon className={classes.plusIcon} />{` Create "${input}"`}</>}
            disableTypography
          />
        </div>
      }
    </Popover>
  );
}

SearchDropDownTab.propTypes = {
  options: PropTypes.shape([]).isRequired,
  values: PropTypes.shape([]).isRequired,
  anchorEl: PropTypes.shape({}).isRequired,
  setAnchorEl: PropTypes.shape({}).isRequired,
  handleSearch: PropTypes.func.isRequired,
  actionHandler: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  seachPlaceholder: PropTypes.string,
  position: PropTypes.shape({
    anchor: PropTypes.string,
    transform: PropTypes.string,
  }),
};
SearchDropDownTab.defaultProps = {
  isLoading: false,
  seachPlaceholder: 'search',
  position: { anchor: { vertical: 'top', horizontal: 'left' }, transform: { vertical: 'top', horizontal: 'right' } },
};
export default SearchDropDownTab;
